import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { loginAction } from '../../Redux/Actions/AuthAction'
import { toast } from 'react-toastify'
import Loader from '../../Common/Loader'

const SignIn = () => {
  const dispatch = useDispatch()
  const [data, setData] = useState({ email: "", password: "" })
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    localStorage.clear();
  }, []);

  const handleChangeInput = (e) => {
    const { name, value } = e?.target
    setData((prevData) => ({
      ...prevData, [name]: value
    }))
  }


  const handleSubmit = (e) => {
    e.preventDefault();
    if (!data.email || !data.password) {
      toast.error("Please enter both email and password.");
      return;
    }
    setLoading(true)
    const payload = {
      email: data?.email,
      password: data?.password
    }
    dispatch(loginAction(payload)).then((res) => {
      setLoading(false)
      if (res?.payload?.token) {
        const token = res?.payload?.token
        localStorage.setItem('token', token)
        window.location.href = "/dashboard"
      } else {
        toast.error('Please check you email and password')
        setLoading(false)
      }
    })
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50">
      {loading && <Loader />}
      <div id="login-screen" className="flex items-center justify-center min-h-screen p-4">
        <div className="login-card bg-white rounded-xl p-8 max-w-md w-full">
          <div className="text-center mb-4">
            <img src="/Images/logomb.png" alt="Medicaid Billing " className="mx-auto mb-1" width="80px" />
            <h4 className="heading-text  font-bold text-gray-800">Welcome to Medicaid Billing Portal</h4>
            {/* <p className="text-gray-600 mt-2 text-center">Complete your Comprehensive Emergency Management Plan</p> */}
          </div>

          <div className="space-y-4">
            <form onSubmit={handleSubmit}>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input name='email' type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  value={data?.email}
                  onChange={handleChangeInput}
                />
              </div>

              <div classNameName="mt-2">
                <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                <input name='password' type="password" id="password" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  value={data?.password}
                  onChange={handleChangeInput}
                />
              </div>

              <div className="pt-2 mt-4">
                <button type="submit" className="btn btn-primary w-100">
                  Sign In
                </button>
              </div>
            </form>
            <div className="text-center mt-3">
              <p className="text-gray-600 mt-2 mb-2 text-center">Don't have an account? <a href="/signup" className="text-blue-600 font-medium">Sign up</a></p>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default SignIn
